import {z} from 'zod'
import {EnvironmentName} from '../EnvironmentName.js'
import {StripePriceId, StripeProductId} from '../../stripe/index.js'
import {EncryptionKey} from '../../encryption/index.js'

export const ApiResolverEnvironmentVariables = z.object({
  ENVIRONMENT_NAME: EnvironmentName,
  COMMIT_SHA: z.string().default('unknown'),
  SENTRY_DSN: z.string(),

  ENCRYPTION_KEY: EncryptionKey,

  AUTH0_DOMAIN: z.string(),
  AUTH0_CLIENT_ID: z.string(),
  AUTH0_CONNECTION_NAME: z.string(),

  MONGODB_CONNECTION_STRING: z.string(),
  MONGODB_DATABASE_NAME: z.string(),
  MONGODB_USERNAME: z.string(),
  MONGODB_PASSWORD: z.string(),

  STRIPE_API_KEY: z.string(),
  STRIPE_WEBHOOK_SECRET_KEY: z.string(),
  STRIPE_STARTER_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
  STRIPE_BASIC_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
  STRIPE_PRO_SUBSCRIPTION_PRODUCT_ID: StripeProductId,
  STRIPE_TRIAL_PRICE_ID: StripePriceId,
  STRIPE_TRIAL_DAYS: z.string(),
})
export type ApiResolverEnvironmentVariables = z.infer<typeof ApiResolverEnvironmentVariables>
